module.exports = __webpack_public_path__ + "asset/img/body-web-popup_250122.4847367b.svg";